if (!customElements.get('lumus-moments-carousel')) {
  customElements.define(
    'lumus-moments-carousel',
    class LumusMomentsCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        this.slides = [...this.querySelectorAll('[data-carousel-slide]')];
        this.dots = [...this.querySelectorAll('[data-carousel-dot]')];
        this.previousButton = this.querySelector('[data-carousel-previous]');
        this.nextButton = this.querySelector('[data-carousel-next]');
        this.index = 0;
        this.startX = null;

        if (this.slides.length < 2) return;

        this.previousButton?.addEventListener('click', () => this.show(this.index - 1));
        this.nextButton?.addEventListener('click', () => this.show(this.index + 1));
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index)));
        this.track.addEventListener('pointerdown', (event) => this.onPointerDown(event));
        this.track.addEventListener('pointerup', (event) => this.onPointerUp(event));
        this.track.addEventListener('pointercancel', () => {
          this.startX = null;
        });
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
        this.addEventListener('focusin', () => this.stopAutoplay());
        this.addEventListener('focusout', () => this.startAutoplay());

        this.show(0, false);
        this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
      }

      show(requestedIndex, restartAutoplay = true) {
        const lastIndex = this.slides.length - 1;
        this.index = this.dataset.loop === 'true'
          ? (requestedIndex + this.slides.length) % this.slides.length
          : Math.max(0, Math.min(requestedIndex, lastIndex));

        this.track.style.transform = `translate3d(-${this.index * 100}%, 0, 0)`;
        this.slides.forEach((slide, index) => {
          slide.setAttribute('aria-hidden', String(index !== this.index));
        });
        this.dots.forEach((dot, index) => {
          dot.setAttribute('aria-current', String(index === this.index));
        });

        if (this.dataset.loop !== 'true') {
          if (this.previousButton) this.previousButton.disabled = this.index === 0;
          if (this.nextButton) this.nextButton.disabled = this.index === lastIndex;
        }

        if (restartAutoplay) {
          this.stopAutoplay();
          this.startAutoplay();
        }
      }

      onPointerDown(event) {
        if (event.button !== 0) return;
        this.startX = event.clientX;
        this.track.setPointerCapture?.(event.pointerId);
      }

      onPointerUp(event) {
        if (this.startX === null) return;
        const distance = event.clientX - this.startX;
        this.startX = null;
        if (Math.abs(distance) < 40) return;
        this.show(this.index + (distance < 0 ? 1 : -1));
      }

      startAutoplay() {
        if (this.dataset.autoplay !== 'true' || this.slides.length < 2) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const delay = Number(this.dataset.autoplaySpeed) * 1000;
        this.autoplayTimer = window.setInterval(() => this.show(this.index + 1, false), delay);
      }

      stopAutoplay() {
        window.clearInterval(this.autoplayTimer);
      }
    }
  );
}
